import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Info } from "lucide-react";
import { FULL_SQUAD } from "@/data/teamData";
import Footer from "@/components/Footer";

// Statistik dummy deterministik dari id (akan diganti data asli).
function dummyStats(id, position) {
  const att = position === "ATT";
  const mid = position === "MID";
  return [
    { label: "PENAMPILAN", value: 8 + ((id * 3) % 12), bar: 60 + ((id * 7) % 35) },
    { label: "GOL", value: att ? (id * 5) % 14 : (id * 2) % 6, bar: att ? 70 : 30 },
    { label: "ASSIST", value: mid ? (id * 3) % 11 : (id * 2) % 7, bar: mid ? 65 : 35 },
    { label: "RATING", value: (7 + ((id * 13) % 25) / 10).toFixed(1), bar: 55 + ((id * 5) % 40) },
  ];
}

export default function PemainDetail() {
  const { id } = useParams();
  const player = FULL_SQUAD.find((p) => String(p.id) === String(id));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!player) {
    return (
      <div className="bg-[#050B14] text-white min-h-screen flex flex-col items-center justify-center px-5 text-center">
        <h1 className="font-display text-5xl mb-4">PEMAIN TIDAK DITEMUKAN</h1>
        <Link to="/skuad" className="inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#D62839] text-white px-6 py-3 text-sm font-bold tracking-wider transition-colors">
          <ArrowLeft size={16} /> LIHAT SKUAD
        </Link>
      </div>
    );
  }

  const stats = dummyStats(player.id, player.position);

  return (
    <div data-testid="pemain-detail-page" className="bg-[#050B14] text-white min-h-screen">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/30sff-logo.png" alt="The 30s FF" className="w-11 h-11 object-contain" />
            <div className="leading-none">
              <div className="font-display text-lg sm:text-xl tracking-wider">THE 30s FF</div>
              <div className="text-[10px] text-white/50 tracking-[0.2em]">OFFICIAL TEAM</div>
            </div>
          </Link>
          <Link
            to="/skuad"
            data-testid="pemain-back"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-wider text-white/80 hover:text-[#E63946] transition-colors"
          >
            <ArrowLeft size={14} /> SKUAD
          </Link>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 grid lg:grid-cols-2 gap-10 items-start">
        {/* Foto */}
        <div className="relative bg-[#0A1128] border border-white/10 overflow-hidden">
          <div className="aspect-[3/4] relative">
            <img src={player.img} alt={player.name} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-transparent to-transparent" />
            {player.num && (
              <div className="absolute top-4 right-4 font-display text-6xl text-white/30">{player.num}</div>
            )}
          </div>
        </div>

        {/* Info + stats */}
        <div>
          <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">{player.positionLabel}</div>
          <h1 className="font-display text-5xl sm:text-6xl leading-none">{player.name}</h1>
          {player.num && (
            <div className="mt-3 text-white/60">Nomor punggung #{player.num}</div>
          )}

          <div className="mt-8 space-y-5">
            {stats.map((s, i) => (
              <div key={i}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs tracking-[0.2em] text-white/60">{s.label}</span>
                  <span className="font-display text-2xl">{s.value}</span>
                </div>
                <div className="h-1.5 bg-white/10 overflow-hidden">
                  <div className="h-full bg-[#E63946]" style={{ width: `${s.bar}%` }} />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 inline-flex items-center gap-2 text-xs bg-[#E63946]/10 border border-[#E63946]/30 text-[#E63946] px-3 py-2">
            <Info size={14} /> Statistik & nomor masih contoh, akan diperbarui dengan data asli.
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
